import { useState, type ReactNode } from "react";
import { t } from "./kieli";

/* ═══════════════════════════════════════════════════════════
   Näkymän ohjelaatikko (Toni 23.9.2026, muoto 25.9.2026).

   Ohje on näkymän YLÄOSASSA eikä alalaidassa: käyttäjä lukee luvut
   vasta kun tietää mitä ne tarkoittavat.

   Kaksi asiaa, aina samassa järjestyksessä: kuka saa tehdä mitä tässä
   näkymässä, ja mitä näkymän luvut tarkoittavat. «Kuka»-osa kuvaa koodin
   portteja, ja kun portti muuttuu, tämä teksti muuttuu samassa commitissa.

   25.9.2026: sisältö ei lyhene, muoto muuttuu. Palstat koko leveydelle
   (kolme leveällä, yksi puhelimessa), ja kytkin pienentää laatikon yhdeksi
   riviksi joka kertoo mitä se sisältää — kokonaan katoava ohje on
   käytännössä poistettu. Valinta on käyttäjä- ja näkymäkohtainen ja
   palvelimella (nayttotila.ts), oletus auki. Näkymän tunnus luetaan
   osoitteesta (#/<näkymä>/…), joten kutsupaikkoja ei tarvinnut muuttaa.
   Kaksi saraketta, yksi osio kumpaankin (Toni 25.9.2026): palstoitus virtasi
   tekstin sarakkeesta toiseen, ja toinen otsikko alkoi keskeltä saraketta.
   Auki-tilassa kytkin on kulmassa eikä omana rivinään ja otsikot ovat
   tekstin alussa: mittari «korkeus puolet» kaatui 25/26 näkymässä, koska
   kytkinrivi ja kaksi otsikkoriviä olivat kiinteä ~60 px lisä.

   12.10.2026 (T537, Toni «T537 GO demoon kun ilta-erä valmis»; pääChatin toimeksianto: «kaikki ohjelaatikot ovat AINA
   oletuksena suljettuja kaikissa näkymissä ja avautuvat vain klikkaamalla. Avattu tila ei jää muistiin»): kumoaa 25.9.:n
   «oletus auki, valinta palvelimella». Suljettu ohje on yksi rivi, joten se ei vie tilaa mistään näkymästä, ja viisi
   taitekuittausta (puutteet, aukot, tuntikirjaus, varasto, osaaminen) poistuivat. Tila on komponentin oma: ei palvelinta,
   ei selaimen muistia — jokainen avaus alkaa suljettuna.
   ═══════════════════════════════════════════════════════════ */

export function Ohje({ kuka, luvut, lukujenOtsikko = t("ohje.luvut") }: {
  kuka: ReactNode; luvut: ReactNode; lukujenOtsikko?: string;
}) {
  const [auki, asetaAuki] = useState(false);
  const tiivistelma = `${t("ohje.ohje")} · ${t("ohje.kuka")} · ${lukujenOtsikko}`;
  return (
    <aside className={"ohje" + (auki ? " ohje--auki" : " ohje--kiinni")} data-ohje={auki ? "auki" : "suljettu"}>
      <button type="button" className="ohje__kytkin" data-ohje-kytkin="" aria-expanded={auki}
              aria-label={auki ? t("ohje.pienenna") : tiivistelma}
              onClick={() => asetaAuki(!auki)}
              title={auki ? t("ohje.pienenna") : t("ohje.avaa")}>
        {!auki && <span className="ohje__i" aria-hidden="true">i</span>}
        {!auki && <span className="ohje__tiivistelma">{tiivistelma}</span>}
        <span aria-hidden="true" className="ohje__nuoli">{auki ? "⌃" : "⌄"}</span>
      </button>
      {auki && (
        <div className="ohje__palstat">
          <p className="ohje__osa" data-ohje-osa="kuka"><strong className="ohje__otsikko">{t("ohje.kuka")}</strong>{" "}{kuka}</p>
          <p className="ohje__osa" data-ohje-osa="luvut"><strong className="ohje__otsikko">{lukujenOtsikko}</strong>{" "}{luvut}</p>
        </div>
      )}
    </aside>
  );
}
